module.exports = __webpack_public_path__ + "static/edit-home1-two-banner-4de06d0ef3e9e61375d60e2169998881.png";